module.exports = __webpack_public_path__ + "img/31-1.7ad93c84.png";